export default {
  table: {
    header: {
      name: '',
      uwb: 'UWB',
      ble: 'BLE',
      wifi: 'WI-FI',
    },
    accuracy: {
      name: 'Độ chính xác',
      uwb: '10 - 50cm',
      ble: 'Dưới 5m',
      wifi: 'Dưới 10m',
    },
    optimumRange: {
      name: 'Phạm vi tối ưu',
      uwb: '10 - 50cm',
      ble: '0–25m',
      wifi: '0–50m',
    },
    maximumRange: {
      name: 'Phạm vi tối đa',
      uwb: '200m',
      ble: '100m',
      wifi: '500m',
    },
    latency: {
      name: 'Độ trễ',
      uwb: '1ms',
      ble: '3–5 giây',
      wifi: '3–5 giây',
    },
    power: {
      name: 'Mức tiêu thụ điện năng',
      uwb: 'Thấp',
      ble: 'Rất thấp',
      wifi: 'Trung bình',
    },
    value: {
      name: 'Chi phí',
      uwb: '₩₩',
      ble: '₩₩',
      wifi: '₩₩₩',
    },
    frequency: {
      name: 'Tần số',
      uwb: '3.1–10.6GHz',
      ble: '2.4GHz',
      wifi: '2.4GHz, 5GHz',
    },
    dataRate: {
      name: 'Tốc độ',
      uwb: 'Tối đa 27Mbps',
      ble: 'Tối đa 2Mbps',
      wifi: 'Tối đa 1Gbps',
    },
  },
  request: {
    title: 'Bạn cần triển khai giải pháp?',
    description: 'Bạn đang cần tư vấn về giải pháp hoặc yêu cầu một bản demo?  <br/> Hãy liên hệ với chúng tôi, chúng tôi sẽ phản hồi lại trong thời gian sớm nhất.',
    button: 'Liên hệ bộ phận kinh doanh',
  },
};
